<template>
    <div id="contenedor-listado-proyecto-documentos-desktop">
      <v-simple-table class="mt-5">
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.value">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(documentos) in listadoAgrupado">
              <template>
                <tr
                  v-for="(documento, index) in documentos"
                  v-show="index === 0
                    || documento.idProyectoDocumentoTipo === mostrarMasVersionesDocumento"
                  :class="{'grey lighten-5': documentos.length > 1 && documento.esUltimo}"
                  :key="documento.id">
                  <td width="5">
                    <div style="position: relative;">
                      <div style="position: absolute; left: -10px; top:-18px;">
                        <v-btn
                          v-if="documentos.length > 1 && documento.esUltimo"
                          icon
                          @click="
                            toggleMostrarDocumentosRelacionados(documento.idProyectoDocumentoTipo)">
                          <v-icon>
                            {{ documento.idProyectoDocumentoTipo !== mostrarMasVersionesDocumento ?
                            'mdi-plus' : 'mdi-minus' }}
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span
                      :class="{'pl-3 font-weight-medium': index !== 0}">
                      {{ documento.proyectoDocumentoTipo.descripcion }}
                    </span>
                  </td>
                  <td>
                    {{ documento.descripcion }}
                  </td>
                  <!-- <td>
                    {{ documento.datosArchivo.name }}
                  </td> -->
                  <td>
                    {{ $moment(documento.fecha).format('DD/MM/YYYY') }}
                  </td>
                  <td>
                    <v-chip>
                      <v-icon
                        class="pl-1"
                        left
                        small>
                        {{ $iconoDeExtension(documento.datosArchivo.extension) }}
                      </v-icon>
                      {{ documento.datosArchivo.extension }}
                    </v-chip>
                  </td>
                  <td>
                    {{ $humanFileSize(documento.datosArchivo.size) }}
                  </td>
                  <td>
                    <FechaHumano
                      :fecha="documento.createdAt">
                    </FechaHumano>
                  </td>
                  <td class="text-center">
                    <v-btn
                      @click="mixDescargarDocumento(documento.datosArchivo)"
                      icon>
                      <v-icon color="success">mdi-download</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-right">
                    <opciones
                      :proyectoDocumento="documento"
                      tipoMenu>
                    </opciones>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <!-- Ventana Agregar Proyecto Documento  -->
    <v-dialog
      v-if="mostrarVentanaAgregarProyectoDocumento"
      v-model="mostrarVentanaAgregarProyectoDocumento"
      persistent
      width="600">
      <agregar-proyecto-documento
      v-if="mostrarVentanaAgregarProyectoDocumento"
      :idProyecto="idProyecto"
      v-on:cerrar="cerrarVentana">
      </agregar-proyecto-documento>
    </v-dialog>
    <!-- Ventana Editar Proyecto Documento  -->
    <v-dialog
      v-if="esteProyectoDocumento"
      v-model="mostrarVentanaEditarProyectoDocumento"
      scrollable
      persistent
      width="600">
      <editar-proyecto-documento
      :proyectoDocumentoEditar="esteProyectoDocumento"
      v-on:cerrar="cerrarVentana">
      </editar-proyecto-documento>
    </v-dialog>
    <!-- Ventana Eliminar Proyecto Documento  -->
    <v-dialog
      v-if="esteProyectoDocumento"
      v-model="mostrarVentanaEiminarProyectoDocumento"
      scrollable
      persistent
      width="400">
      <eliminar-proyecto-documento
      :proyectoDocumentoEliminar="esteProyectoDocumento"
      v-on:cerrar="cerrarVentana">
      </eliminar-proyecto-documento>
    </v-dialog>
    </div>
  </template>

<script>
import PROYECTO_DOCUMENTOS from '@/graphql/querys/administracion/control-proyectos/documentos/proyectoDocumentos.gql';
import eventBus from '@/helpers/eventBus';
import FechaHumano from '@/components/FechaHumano.vue';
import AgregarProyectoDocumento from '../Agregar.vue';
import EditarProyectoDocumento from '../Editar.vue';
import EliminarProyectoDocumento from '../Eliminar.vue';
import Opciones from './Opciones.vue';
import mixProyectosDocumentos from '../mixProyectosDocumentos';

export default {
  name: 'ListadoProyectoDocumentosDesktop',
  mixins: [mixProyectosDocumentos],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    AgregarProyectoDocumento,
    EditarProyectoDocumento,
    EliminarProyectoDocumento,
    FechaHumano,
    // ToolBar,
    Opciones,
  },
  apollo: {
    proyectoDocumentos: {
      query: PROYECTO_DOCUMENTOS,
      variables() {
        return {
          idProyecto: this.idProyecto,
        };
      },
    },
  },
  data() {
    return {
      mostrarMasVersionesDocumento: null,
      mostrarVentanaAgregarProyectoDocumento: false,
      mostrarVentanaEditarProyectoDocumento: false,
      mostrarVentanaEiminarProyectoDocumento: false,
      esteProyectoDocumento: null,
      headers: [
        { text: '', sortable: false, value: 'accion' },
        { text: 'Tipo Documento', sortable: false, value: 'proyectoDocumentoTipo.descripcion' },
        { text: 'Descripción', sortable: false, value: 'descripcion' },
        // { text: 'Nombre Archivo', sortable: false, value: 'datosArchivo.name' },
        {
          text: 'Fecha', align: 'center', sortable: false, value: 'fecha',
        },
        {
          text: 'Tipo', sortable: false, align: 'center', value: 'datosArchivo.extension',
        },
        {
          text: 'Tamaño', sortable: false, align: 'center', value: 'datosArchivo.size',
        },
        {
          text: 'F. Registro', sortable: false, align: 'center', value: 'fechaRegistro',
        },
        {
          text: '', sortable: false, align: 'center', value: 'descargar',
        },
        {
          text: '', align: 'end', sortable: false, value: 'acciones',
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('editar-proyecto-documento', (proyectoDocumento) => {
      this.mostrarVentanaEditarProyectoDocumento = true;
      this.esteProyectoDocumento = proyectoDocumento;
    });
    eventBus.$on('eliminar-proyecto-documento', (proyectoDocumento) => {
      this.mostrarVentanaEiminarProyectoDocumento = true;
      this.esteProyectoDocumento = proyectoDocumento;
    });
  },
  methods: {
    toggleMostrarDocumentosRelacionados(tipoDocumento) {
      if (this.mostrarMasVersionesDocumento === null
        || this.mostrarMasVersionesDocumento !== tipoDocumento) {
        this.mostrarMasVersionesDocumento = tipoDocumento;
      } else {
        this.mostrarMasVersionesDocumento = null;
      }
    },
    cerrar() {
      this.$emit('cerrar');
    },
    cerrarVentana() {
      this.mostrarVentanaAgregarProyectoDocumento = false;
      this.mostrarVentanaEditarProyectoDocumento = false;
      this.mostrarVentanaEiminarProyectoDocumento = false;
      this.esteProyectoDocumento = null;
    },
    agregarNuevoProyectoDocumento() {
      this.mostrarVentanaAgregarProyectoDocumento = true;
    },
    groupBy(array, key) {
      return array.reduce((result, currentValue) => {
        // Get the key value to group by
        const groupKey = currentValue[key];

        // If the group key doesn't exist in the result object, create it
        if (!result[groupKey]) {
          // eslint-disable-next-line no-param-reassign
          result[groupKey] = [];
        }

        // Add the current value to the group
        result[groupKey].push(currentValue);

        // Return the result object for the next iteration
        return result;
      }, {});
    },
  },
  computed: {
    getProyectoDocumentos() {
      if (!this.proyectoDocumentos) return [];
      const proyectoDocumentosFormateado = this.proyectoDocumentos.slice()
        .map((proyectoDocumento) => ({
          ...proyectoDocumento,
          datosArchivo: JSON.parse(proyectoDocumento.fileData),
        }));
      return proyectoDocumentosFormateado;
    },
    listadoAgrupado() {
      if (!this.proyectoDocumentos) return [];
      return this.groupBy(this.getProyectoDocumentos
        .slice()
        .sort((a, b) => b.esUltimo - a.esUltimo), 'idProyectoDocumentoTipo');
    },
  },
};
</script>

  <style lang="scss">

  </style>
